import React from 'react'
import styled from "styled-components";
import * as media from "../../../../media";
import DesktopBanner from './Desktop'
import MobileBanner from './Mobile'

const BiggerThan1000Check = styled.div`
  ${media.smallerThan(920)`display:none;`}
`
const LessThan1000Check = styled.div`
  ${media.biggerThan(921)`display:none;`}
`

export default function AutoPartCard(props) {
  return (
    <div>
      <BiggerThan1000Check>
        <DesktopBanner {...props} />
      </BiggerThan1000Check>
      <LessThan1000Check>
        <MobileBanner {...props}/>
      </LessThan1000Check>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/finwhale/common/price-list-request/modal/index.js